import React, { Component, PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';
import css from './footer.scss';
import logo from './fwa-logo.png';
import rackFish from './rackfish.png';
import baseUrl from '../../utils/baseUrl';
import { genericRoute } from '../../routes';
import gaPush from '../../utils/gaTrack';

//import css from './header.scss';

export default class Footer extends Component {
	static propTypes = {};
	static defaultProps = {
		footerItems: {},
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		//menuActionCreator.updateStickyFooter();
	}

	render() {
		let year = new Date();
		year = year.getFullYear();

		return (
			<footer className='footer-container span14'>
				<div className='footer-container__column footer-container__column--no-border hide-mobile span2 span3-tablet'>
					<Link className='footer-container__column__logo' to={genericRoute(false, '', false)}>
						<img src={logo.src} />
					</Link>
				</div>
				<div className="footer-container__column__flex">
					<div className='footer-container__column span10 span8-tablet span7-mobile'>
						<ul className='footer-container__menu'>
							{this.props.footerItems.map((link, i) => this.renderLink(link, i))}
						</ul>
						<span className='footer-container__notice hide-mobile'>All rights reserved © 2000—{year}  The FWA</span>
					</div>
					<div className='footer-container__column span2 span3-tablet span7-mobile'>
						<a href='http://www.rackfish.com/' target='_blank' onClick={()=>gaPush('event', 'ads', 'rackfish')} className='footer-container__sponsor'><img src={rackFish.src} /></a>
					</div>
				</div>
				<div className='footer-container__column footer-container__column--big span14 hide-tablet hide-desktop'>
					<Link className='footer-container__column__logo' to={genericRoute(false, '', false)}>
						<img src={logo.src} />
					</Link>
					<span className='footer-container__notice'>All rights reserved © 2000—{year}  The FWA</span>
				</div>
			</footer>
		);
	}

	renderLink(link, i) {
		return(
			<li className='footer-container__menu__link' key={'footer-link-' + i}>
				<Link to={genericRoute(link.slug)}>{link.name}</Link>
			</li>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/footer/footer.js
 **/